/* eslint-disable react/prop-types */
/* eslint-disable  no-nested-ternary */
import { connect, useDispatch, useSelector } from 'react-redux';
import {
  useState,
  useLayoutEffect,
  useEffect
} from 'react';
import { Route } from 'react-router-dom';
import WrapLayout from 'Components/WrapLayout';
import { getCname } from 'Actions/Company';
import {
  SetStorage,
  GetStorage,
  decryptCID,
  SignCurrentUser,
  CleanupSessionStorage,
  CleanupCrypticStorage,
  GetAPIBaseURL,
  ExtractingParams,
  ExplodeCIDParams,
  RedirectToSsoSignout,
  GenerateDataProductTour,
  DecodeCurrentUser,
} from 'Helpers';
import ReactGA from 'react-ga';
import { hotjar } from "react-hotjar";
import { CID, CURRENT_USER, PATH_NAME } from 'Config/constants';
import { getCheckAuth, getCurrentUser, setCurrentCompany } from 'Actions/User';
import { api } from 'Helpers/ApiCall';
import {
  API_DASHBOARD_TRACKER,
  API_FEATURE_TOGGLE,
  API_LOU_TRACKER,
  LOU_ENABLED
} from 'Config/api';

function PrivateRoute({ component: Component, onGetCname, ...rest }) {
  const dispatch = useDispatch();
  const { component, route } = rest.additionalRoute;
  const [currentCID, setCurrentCID] = useState(null);

  const checkAuth = useSelector((state) => state.checkAuth);
  const currentUser = useSelector((state) => state.currentUser);
  const signOut = useSelector((state) => state.signOut);
  const [teamManagerToggle, setTeamManagerToggle] = useState(false);

  const postDashboardTracker = async () => {
    // set endTime
    const endTime = performance.now();
    // Count page load time
    const pageLoadTime = endTime - window.startTime;

    await api(
      'POST',
      GetAPIBaseURL(),
      API_DASHBOARD_TRACKER,
      {
        dashboard_name: rest.name,
        load_time_page: pageLoadTime,
        source: 'Talenta Insight',
      },
      '',
      null,
      { 'Content-Type': 'application/json' }
    );
  };

  const postLouTracker = async (params) => {
    await api(
      'POST',
      GetAPIBaseURL(),
      API_LOU_TRACKER,
      {
        dashboard: {
          dashboard_name: rest.name,
          lou_tracker: {
            event: params.event,  // eslint-disable-line
            attr: params.attr  // eslint-disable-line
          }
        }
      },
      '',
      null,
      { 'Content-Type': 'application/json' }
    );
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    setTimeout(() => {
      hotjar.initialize(process.env.REACT_APP_HOTJAR_ID, process.env.REACT_APP_HOTJAR_SNIPPET_VERSION);
    }, 500);

    setTimeout(() => {
      ReactGA.pageview(window.location.pathname + window.location.search);
    }, 1000);


    if (params.get('cid')) {
      const segments = ExplodeCIDParams(params.get('cid'));
      if (segments !== null && segments.length === 4) {
        ExtractingParams(segments);
      } else {
        window.location.href = '/';
      }
    } else {
      const currentUserStorage = GetStorage(CURRENT_USER)?.attr;
      if (!currentUserStorage) {
        dispatch(getCurrentUser());
      } else {
        dispatch(getCheckAuth());
      }
    }

    SetStorage(PATH_NAME, window.location.pathname)
  }, []);

  useEffect(() => {
    const companyId = decryptCID(GetStorage(CID)?.attr);
    if (companyId) {
      setCurrentCID(companyId);
    }
  }, []);

  useEffect(async () => {
    try {
      await api(
        'GET',
        GetAPIBaseURL(),
        `${API_FEATURE_TOGGLE}/team_manager_dashboard`,
        null,
        '',
      );
      setTeamManagerToggle(true);
    } catch (error) {
      setTeamManagerToggle(false);
    }
  }, [])
  
  useEffect(() => {
    if (checkAuth?.status === 200) {
      onGetCname();
      postDashboardTracker();

      if (parseInt(LOU_ENABLED, 10) === 1) {
        setTimeout(() => {
          const getDataProductTour = GenerateDataProductTour();

          if (getDataProductTour !== false) {
            /* global LOU */
            /* eslint no-undef: "error" */
            LOU.identify(getDataProductTour.sso_id, {
              sso_id: getDataProductTour.sso_id,
              t_user_id: getDataProductTour.user_id,
              t_role: getDataProductTour.role_name,
              t_company_id: getDataProductTour.company.id,
              sso_company_id: getDataProductTour.company.sso_id,
              t_company_size: getDataProductTour.company.size,
              t_company_name: getDataProductTour.company.name,
              t_company_status: getDataProductTour.company.status,
              t_company_go_live_status: getDataProductTour.company.go_live_status,
              t_is_staging: getDataProductTour.is_staging,
              is_access_talenta_insight: getDataProductTour.is_login_insight,
              talenta_insights_dashboard: rest.name,
            });

            LOU.listen('all', (event) => {
              postLouTracker({ event: event.detail.name, attr: event.detail.data })
            });
          }
        }, 1000);
      }

      const MoengageInit = window.moe({
        app_id: process.env.REACT_APP_MOENGAGE_API_ID,
        debug_logs: 0,
        enableSPA: true
      });

      const decodedUser = DecodeCurrentUser()
      if (decodedUser !== false) {
        const jsonUser = JSON.parse(decodedUser);
        const user = jsonUser.current_user;
        const companyId = jsonUser.current_company.company.id;

        MoengageInit.add_unique_user_id(`${user.id}_${companyId}`);

        MoengageInit.add_first_name(user.first_name);
        MoengageInit.add_last_name(user.last_name);
        MoengageInit.add_email(user.email);
        MoengageInit.add_mobile(user.mobile_phone);
        MoengageInit.add_user_name(`${user.first_name} ${user.last_name}`);

        MoengageInit.add_user_attribute('company_id', companyId);
        MoengageInit.add_user_attribute('access_insights', true);
      }
    }
  }, [checkAuth])

  useEffect(() => {
    if (currentCID) {
      dispatch(setCurrentCompany(currentCID))
    }
  }, [currentCID]);

  useEffect(() => {
    if (currentUser?.data && currentUser.status === 200) {
      SetStorage(CURRENT_USER, SignCurrentUser(currentUser?.data));
      CleanupCrypticStorage();
      window.location.href = GetStorage(PATH_NAME)?.attr || '/';
    }

    if (currentUser?.status === 403) {
      CleanupCrypticStorage();
    }
  }, [currentUser]);


  useEffect(() => {
    if (Number.isInteger(signOut.status)) {
      CleanupSessionStorage();
      RedirectToSsoSignout();
    }
  }, [signOut]);

  // set startTime with window performance
  useLayoutEffect(() => {
    window.startTime = window.performance.now();
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => (
        <WrapLayout
          {...props}
          component={component}
          route={route}
          teamManagerToggle={teamManagerToggle}
        />
      )}
    />
  );
}

const mapDispatchToProps = (dispatch) => ({
  onGetCname: () => dispatch(getCname()),
});
export default connect(null, mapDispatchToProps)(PrivateRoute);
